<script>
    import Icon from '../icons/Icon.svelte';
    import { getNicheTemplate } from '../../data/nicheTemplates.js';

    export let businessProfile = 'hamburgueria';
    export let name = '';
    export let slug = '';
    export let phone = '';
    export let cnpj = '';
    export let address = '';
    export let storeLogo = '';
    export let storeBanner = '';
    export let primaryColor = '#EA580C';
    export let instagram = '';
    export let onOpenNicheModal = () => {};
    export let handleStoreLogoUpload = () => {};
    export let removeStoreLogo = () => {};
    export let handleStoreBannerUpload = () => {};
    export let removeStoreBanner = () => {};
    export let copyCardapioUrl = () => {};
    export let copiedCardapio = false;

    let logoInputRef;
    let bannerInputRef;

    $: currentNiche = getNicheTemplate(businessProfile);

    const colorPresets = [
        { name: 'Laranja MataFome', hex: '#EA580C' },
        { name: 'Vermelho Pizzaria', hex: '#DC2626' },
        { name: 'Roxo Açaí', hex: '#7C3AED' },
        { name: 'Verde Natural', hex: '#16A34A' },
        { name: 'Amarelo Mostarda', hex: '#D97706' },
        { name: 'Rosa Pastel', hex: '#E11D48' },
        { name: 'Azul Marinho', hex: '#2563EB' }
    ];
</script>

<div class="tab-pane">
    <!-- 1. Card de Destaque do Ramo / Nicho -->
    <section class="settings-card highlight-card">
        <div class="niche-banner">
            <div class="niche-icon-large" style="background: {currentNiche.themeColor}25; color: {currentNiche.themeColor};">
                <Icon name={currentNiche.svgIcon || 'utensils'} size={32} />
            </div>
            <div class="niche-info">
                <div class="niche-badge-row">
                    <span class="sub-badge">RAMO ATIVO DO ESTABELECIMENTO</span>
                    {#if currentNiche.badge}
                        <span class="niche-pill" style="background: {currentNiche.themeColor}22; color: {currentNiche.themeColor}; border: 1px solid {currentNiche.themeColor}44;">
                            {currentNiche.badge}
                        </span>
                    {/if}
                </div>
                <h3>{currentNiche.name}</h3>
                <p>{currentNiche.description}</p>
            </div>
            <div class="niche-action">
                <button type="button" class="btn-change-niche" on:click={onOpenNicheModal}>
                    <Icon name="refresh" size={14} />
                    <span>Alterar Ramo / Presets</span>
                </button>
            </div>
        </div>
    </section>

    <!-- 2. Link do Cardápio Digital -->
    <section class="settings-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="globe" size={18} />
                <h4>Cardápio Digital & Link Público</h4>
            </div>
            <span class="card-subtitle">Este é o link que os clientes acessam no WhatsApp, Instagram e QR Code das mesas.</span>
        </div>

        <div class="cardapio-link-box">
            <div class="link-display">
                <span class="link-prefix">{typeof window !== 'undefined' ? window.location.origin : 'https://app.matafome.com'}/cardapio/</span>
                <span class="link-slug">{slug || 'sua-loja'}</span>
            </div>
            <div class="link-actions">
                <button type="button" class="btn-copy-link" on:click={copyCardapioUrl}>
                    <Icon name={copiedCardapio ? 'check' : 'copy'} size={14} />
                    <span>{copiedCardapio ? 'Copiado!' : 'Copiar Link'}</span>
                </button>
                {#if slug}
                    <a
                        href="/cardapio/{slug}"
                        target="_blank"
                        rel="noreferrer"
                        class="btn-open-link"
                    >
                        <Icon name="eye" size={14} />
                        <span>Visualizar</span>
                    </a>
                {/if}
            </div>
        </div>
    </section>

    <!-- 3. Dados Básicos do Restaurante -->
    <section class="settings-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="building" size={18} />
                <h4>Dados Principais da Empresa</h4>
            </div>
            <span class="card-subtitle">Informações visíveis aos clientes e nas notas fiscais/comandas.</span>
        </div>

        <div class="form-grid">
            <div class="form-group full-width">
                <label for="store-name">Nome do Restaurante / Estabelecimento *</label>
                <input
                    id="store-name"
                    type="text"
                    bind:value={name}
                    placeholder="Ex: Pizzaria Forno Nobre"
                    class="form-input"
                    required
                />
            </div>

            <div class="form-group">
                <label for="store-phone">Telefone / WhatsApp de Atendimento</label>
                <input
                    id="store-phone"
                    type="text"
                    bind:value={phone}
                    placeholder="(00) 00000-0000"
                    class="form-input"
                />
            </div>

            <div class="form-group">
                <label for="store-cnpj">CNPJ / CPF do Estabelecimento</label>
                <input
                    id="store-cnpj"
                    type="text"
                    bind:value={cnpj}
                    placeholder="00.000.000/0001-00"
                    class="form-input"
                />
            </div>

            <div class="form-group">
                <label for="store-instagram">Instagram (@da_loja)</label>
                <input
                    id="store-instagram"
                    type="text"
                    bind:value={instagram}
                    placeholder="@seurestaurante"
                    class="form-input"
                />
            </div>

            <div class="form-group">
                <label for="store-slug">Slug Personalizado (URL do Cardápio)</label>
                <input
                    id="store-slug"
                    type="text"
                    bind:value={slug}
                    placeholder="ex: forno-nobre"
                    class="form-input"
                />
            </div>

            <div class="form-group full-width">
                <label for="store-address">Endereço Completo (Rua, Número, Bairro, Cidade)</label>
                <input
                    id="store-address"
                    type="text"
                    bind:value={address}
                    placeholder="Rua das Flores, 123 - Centro - Cidade/UF"
                    class="form-input"
                />
            </div>
        </div>
    </section>

    <!-- 4. Identidade Visual (Logo, Banner e Cores) -->
    <section class="settings-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="sparkles" size={18} />
                <h4>Identidade Visual do Cardápio</h4>
            </div>
            <span class="card-subtitle">Personalize as fotos e a paleta de cores do seu cardápio digital.</span>
        </div>

        <div class="media-grid">
            <!-- Logotipo Circular -->
            <div class="media-box">
                <span class="media-label">Logotipo da Loja (Avatar)</span>
                <div class="logo-preview-wrapper">
                    {#if storeLogo}
                        <img src={storeLogo} alt="Logotipo" class="logo-img-preview" />
                    {:else}
                        <div class="logo-placeholder" style="border-color: {primaryColor}; color: {primaryColor};">
                            <Icon name="utensils" size={32} />
                        </div>
                    {/if}
                </div>
                <div class="media-btn-row">
                    <input
                        type="file"
                        accept="image/*"
                        bind:this={logoInputRef}
                        on:change={handleStoreLogoUpload}
                        class="hidden-file-input"
                    />
                    <button type="button" class="btn-media-upload" on:click={() => logoInputRef.click()}>
                        <Icon name="edit" size={13} />
                        <span>{storeLogo ? 'Alterar Logo' : 'Enviar Logo'}</span>
                    </button>
                    {#if storeLogo}
                        <button type="button" class="btn-media-remove" on:click={removeStoreLogo} title="Remover Logo">
                            <Icon name="trash" size={13} />
                        </button>
                    {/if}
                </div>
            </div>

            <!-- Foto de Capa (Banner) -->
            <div class="media-box full-flex">
                <span class="media-label">Foto de Capa (Banner de Topo)</span>
                <div class="banner-preview-wrapper">
                    {#if storeBanner}
                        <img src={storeBanner} alt="Foto de Capa" class="banner-img-preview" />
                    {:else}
                        <div class="banner-placeholder">
                            <Icon name="camera" size={24} />
                            <span>Sem foto de capa cadastrada (fundo padrão em uso)</span>
                        </div>
                    {/if}
                </div>
                <div class="media-btn-row">
                    <input
                        type="file"
                        accept="image/*"
                        bind:this={bannerInputRef}
                        on:change={handleStoreBannerUpload}
                        class="hidden-file-input"
                    />
                    <button type="button" class="btn-media-upload" on:click={() => bannerInputRef.click()}>
                        <Icon name="edit" size={13} />
                        <span>{storeBanner ? 'Alterar Capa' : 'Enviar Capa'}</span>
                    </button>
                    {#if storeBanner}
                        <button type="button" class="btn-media-remove" on:click={removeStoreBanner} title="Remover Capa">
                            <Icon name="trash" size={13} />
                        </button>
                    {/if}
                </div>
            </div>
        </div>

        <!-- Cores da Marca -->
        <div class="color-palette-section">
            <span class="media-label">Cor de Destaque da Loja</span>
            <div class="colors-row">
                {#each colorPresets as preset}
                    <button
                        type="button"
                        class="color-preset-btn {primaryColor === preset.hex ? 'active' : ''}"
                        style="background: {preset.hex};"
                        title={preset.name}
                        on:click={() => primaryColor = preset.hex}
                    >
                        {#if primaryColor === preset.hex}
                            <Icon name="check" size={14} color="#fff" />
                        {/if}
                    </button>
                {/each}
                <div class="custom-color-picker">
                    <input type="color" bind:value={primaryColor} class="native-color-input" title="Cor personalizada" />
                    <span class="hex-text">{primaryColor}</span>
                </div>
            </div>
        </div>
    </section>
</div>

<style>
    .tab-pane {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .settings-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 22px 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .highlight-card {
        background: #FFFFFF;
        border: 1px solid #FED7AA;
        box-shadow: 0 2px 8px rgba(234, 88, 12, 0.06);
    }

    .niche-banner {
        display: flex;
        align-items: center;
        gap: 20px;
        flex-wrap: wrap;
    }

    .niche-icon-large {
        width: 56px;
        height: 56px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .niche-info {
        flex: 1;
        min-width: 220px;
    }

    .niche-badge-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
    }

    .sub-badge {
        font-size: 10px;
        font-weight: 800;
        color: #EA580C;
        letter-spacing: 0.6px;
        text-transform: uppercase;
    }

    .niche-pill {
        font-size: 11px;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 4px;
    }

    .niche-info h3 {
        font-size: 18px;
        font-weight: 800;
        color: #0F172A;
        margin: 0 0 3px 0;
        letter-spacing: -0.3px;
    }

    .niche-info p {
        font-size: 13px;
        color: #64748B;
        margin: 0;
        line-height: 1.4;
    }

    .btn-change-niche {
        background: #F8FAFC;
        border: 1px solid #CBD5E1;
        color: #334155;
        padding: 9px 16px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        transition: all 0.15s ease;
    }

    .btn-change-niche:hover {
        background: #FFF7ED;
        border-color: #EA580C;
        color: #EA580C;
    }

    .card-header {
        margin-bottom: 16px;
    }

    .card-title-group {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0F172A;
    }

    .card-title-group h4 {
        font-size: 15px;
        font-weight: 700;
        color: #0F172A;
        margin: 0;
    }

    .card-subtitle {
        font-size: 12.5px;
        color: #64748B;
        display: block;
        margin-top: 3px;
    }

    .cardapio-link-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        padding: 12px 16px;
        gap: 12px;
        flex-wrap: wrap;
    }

    .link-display {
        font-family: inherit;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .link-prefix {
        color: #64748B;
    }

    .link-slug {
        color: #EA580C;
        font-weight: 700;
    }

    .link-actions {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .btn-copy-link, .btn-open-link {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #334155;
        padding: 7px 14px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        text-decoration: none;
        transition: all 0.15s ease;
    }

    .btn-copy-link:hover, .btn-open-link:hover {
        background: #FF6A00;
        border-color: #EA580C;
        color: #FFFFFF;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 16px;
    }

    .full-width {
        grid-column: 1 / -1;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 12.5px;
        font-weight: 600;
        color: #334155;
    }

    .form-input {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 9px 12px;
        color: #0F172A;
        font-size: 13px;
        outline: none;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
    }

    .form-input:focus {
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.15);
    }

    .media-grid {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        margin-bottom: 20px;
    }

    .media-box {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .media-box.full-flex {
        flex: 1;
        min-width: 280px;
    }

    .media-label {
        font-size: 12.5px;
        font-weight: 600;
        color: #334155;
    }

    .logo-preview-wrapper {
        width: 80px;
        height: 80px;
        border-radius: 10px;
        overflow: hidden;
        border: 2px solid #E2E8F0;
        background: #F8FAFC;
    }

    .logo-img-preview {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .logo-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #F8FAFC;
        color: #94A3B8;
    }

    .banner-preview-wrapper {
        height: 80px;
        border-radius: 10px;
        overflow: hidden;
        border: 2px solid #E2E8F0;
        background: #F8FAFC;
    }

    .banner-img-preview {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .banner-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: #F8FAFC;
        color: #94A3B8;
        font-size: 12px;
    }

    .media-btn-row {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .hidden-file-input {
        display: none;
    }

    .btn-media-upload {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #334155;
        padding: 7px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        transition: all 0.15s ease;
    }

    .btn-media-upload:hover {
        background: #F1F5F9;
        color: #0F172A;
        border-color: #94A3B8;
    }

    .btn-media-remove {
        background: #FEF2F2;
        border: 1px solid #FCA5A5;
        color: #DC2626;
        padding: 7px 10px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-media-remove:hover {
        background: #FEE2E2;
        color: #B91C1C;
    }

    .color-palette-section {
        border-top: 1px solid #E2E8F0;
        padding-top: 16px;
    }

    .colors-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 8px;
        flex-wrap: wrap;
    }

    .color-preset-btn {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 2px solid transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.15s ease;
    }

    .color-preset-btn:hover {
        transform: scale(1.1);
    }

    .color-preset-btn.active {
        border-color: #0F172A;
        box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.25);
    }

    .custom-color-picker {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #F8FAFC;
        padding: 4px 10px;
        border-radius: 20px;
        border: 1px solid #E2E8F0;
    }

    .native-color-input {
        width: 24px;
        height: 24px;
        border: none;
        border-radius: 50%;
        background: none;
        cursor: pointer;
    }

    .hex-text {
        font-family: inherit;
        font-size: 12px;
        font-weight: 700;
        color: #334155;
    }
</style>
